import {
  VALIDATE_USER,
  GET_MY_JOBS,
  GET_ALL_APPLIED_JOBS,
  GET_PROFILE,
  OTP_VERIFICATION,
  GET_OFFICE_WORKBOARD_DETAILS,
  PHONE_VERIFICATION,
  CATEGORIES,
  CATEGORY_DETAILS,
  CATEGORY_APPLICATIONS,
  APPLIED_FOR_CATEGORY,
  APPLIED_CATEGORIES,
  GET_APPLICATION_DETAILS,
  WORK_REQUIREMENT,
  ALL_REQUIREMENTS,
  MY_REQUIREMENTS_ANALYSE,
  REQUIREMENTS_ANALYSE,
  WORK_ORDERS,
  WORK_ORDER,
  MY_WORK_ORDERS,
  WORK_REPORT,
  WORK_REPORTS,
  WORK_REPORTS_ANALYSE
} from '../../types';

import { removeAllCookie } from '../../../utils/cookie';

export const signOutSuccess = (dispatch) => {
  removeAllCookie();
  dispatch({ type: `${GET_MY_JOBS}_success`, payload: null });
  dispatch({ type: `${GET_ALL_APPLIED_JOBS}_success`, payload: null });
  dispatch({ type: `${GET_PROFILE}_success`, payload: null });
  dispatch({ type: `${OTP_VERIFICATION}_success`, payload: null });
  dispatch({ type: `${GET_OFFICE_WORKBOARD_DETAILS}_success`, payload: null });
  dispatch({ type: `${PHONE_VERIFICATION}_success`, payload: null });
  dispatch({ type: `${OTP_VERIFICATION}_success`, payload: null });
  dispatch({ type: `${VALIDATE_USER}_success`, payload: null });
  dispatch({ type: `${CATEGORIES}_success`, payload: null });
  dispatch({ type: `${CATEGORY_DETAILS}_success`, payload: null });
  dispatch({ type: `${CATEGORY_APPLICATIONS}_success`, payload: null });
  dispatch({ type: `${APPLIED_FOR_CATEGORY}_success`, payload: null });
  dispatch({ type: `${APPLIED_CATEGORIES}_success`, payload: null });
  dispatch({ type: `${GET_APPLICATION_DETAILS}_success`, payload: null });
  dispatch({ type: `${WORK_REQUIREMENT}_success`, payload: null });
  dispatch({ type: `${ALL_REQUIREMENTS}_success`, payload: null });
  dispatch({ type: `${MY_REQUIREMENTS_ANALYSE}_success`, payload: null });
  dispatch({ type: `${REQUIREMENTS_ANALYSE}_success`, payload: null });
  dispatch({ type: `${WORK_ORDERS}_success`, payload: null });
  dispatch({ type: `${WORK_ORDER}_success`, payload: null });
  dispatch({ type: `${MY_WORK_ORDERS}_success`, payload: null });
  dispatch({ type: `${WORK_REPORT}_success`, payload: null });
  dispatch({ type: `${WORK_REPORTS}_success`, payload: null });
  dispatch({ type: `${WORK_REPORTS_ANALYSE}_success`, payload: null });

  if (typeof window !== 'undefined') {
    localStorage.removeItem('profile_image');
    localStorage.removeItem('existing_user_data');
    localStorage.removeItem('dwms_profile_data');
  }

  return Promise.resolve('success');
};
